export default {
    title: "目录",
    noAvailableItems: "没有可供订购的产品。"
}